import React, { useMemo } from "react";
import { useTranslation } from "react-i18next";
import { useSelector } from "react-redux";
import { GetCostCenter } from "../../../../../../graphql/costCenter";
import EntryRow from "./EntryRow";
import {
  buildCostCenterCatalogMap,
  entryHasLineCostCenters,
} from "./entryLineCostCentersDisplay";
import "./EntryRowList.scss";

const EntryRowList = ({
  entries = [],
  fetching = false,
  classNamePrefix = 'entry',
  listClassName = '',
  emptyMessage,
  onEditEntry,
  onDuplicateEntry,
  onReverseEntry,
  onDevengarEntry,
  onDeleteEntry,
}) => {
  const { t } = useTranslation("accounting");
  const resolvedEmptyMessage = emptyMessage ?? t("entries.empty");
  const { selectedCompany } = useSelector((state) => state.companyList);

  const needsCostCenterCatalog = useMemo(
    () => entries.some((entry) => entryHasLineCostCenters(entry)),
    [entries],
  );

  const { data: costCenterData } = GetCostCenter(
    needsCostCenterCatalog ? selectedCompany?.id : null,
  );

  const costCenterCatalogById = useMemo(
    () => buildCostCenterCatalogMap(costCenterData?.getManyCostCenter ?? []),
    [costCenterData],
  );

  if (fetching) {
    return (
      <div className="entry-row-list-loading">
        <p>{t("common.loading")}</p>
      </div>
    );
  }

  if (!entries || entries.length === 0) {
    return (
      <div className="entry-row-list-empty">
        <p>{resolvedEmptyMessage}</p>
      </div>
    );
  }

  return (
    <div
      className={[
        'entry-row-list',
        entries.length >= 2 ? 'has-entries' : '',
        listClassName,
      ]
        .filter(Boolean)
        .join(' ')}
    >
      {entries.map((entry) => (
        <EntryRow
          key={entry.id || entry._id}
          entry={entry}
          currency={entry.currency || 'CLP'}
          classNamePrefix={classNamePrefix}
          costCenterCatalogById={costCenterCatalogById}
          onEditEntry={onEditEntry}
          onDuplicateEntry={onDuplicateEntry}
          onReverseEntry={onReverseEntry}
          onDevengarEntry={onDevengarEntry}
          onDeleteEntry={onDeleteEntry}
        />
      ))}
    </div>
  );
};

export default EntryRowList;
